export default __webpack_public_path__ + "static/media/n-03.fbeccc70.jpg";